import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
// No `toJSON()`: the `DELETE` this command drives carries no body — only the route identifies the speaker.
class UnassignTranscriptSpeaker {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly speakerId: number,
	) {
		Object.freeze(this);
	}
}

export default UnassignTranscriptSpeaker;
